import { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { TableCellCustom } from '@app/components/table';
import { IClientDetailsSchema } from '../types';
import { StatusTag } from '@app/components';
import { ClientProjectStatus } from '@app/constants';
import { selectEmployeesState, getEmployees } from '@app/modules/employees';
import { CustomAvatar, CustomAvatarGroup } from '@app/components/custom-avatar';

interface Props {
  row: IClientDetailsSchema;
}

const ClientDetailsRow = (props: Props) => {
  const { row } = props;
  const statusMapping: Record<string, ClientProjectStatus> = {
    Draft: ClientProjectStatus.Draft,
    InProgress: ClientProjectStatus.InProgress,
    Hold: ClientProjectStatus.Hold,
    Delivered: ClientProjectStatus.Delivered,
  };

  const StatusValue = statusMapping[row.status] || ClientProjectStatus.Draft;
  const employeeState = useSelector(selectEmployeesState);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployees());
  }, [dispatch]);

  const managerNames = row?.managers?.map((managerId: any) => {
    const managers = employeeState.data?.records.find((member: any) => member.id === managerId);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const managerName = `${managers?.firstName} ${managers?.lastName}`;
    return managerName;
  });
  const teamMember = row?.members?.map((memberId: any) => {
    const members: any = employeeState.data?.records?.find((member: any) => member.id === memberId);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const memberName = `${members?.firstName} ${members?.lastName}`;
    return memberName;
  });

  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.id ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.name ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <StatusTag status={ClientProjectStatus[StatusValue]} />
      </TableCellCustom>
      <TableCellCustom flex>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <CustomAvatarGroup max={3}>
            {managerNames?.length > 0 &&
              managerNames?.map((manager: any, index: number) => (
                <CustomAvatar key={index} name={manager} color="info" />
              ))}
          </CustomAvatarGroup>
        </Stack>
      </TableCellCustom>
      <TableCellCustom>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <CustomAvatarGroup max={10}>
            {teamMember?.length > 0 &&
              teamMember.map((team: any, index: number) => (
                <CustomAvatar key={index} name={team} color="info" />
              ))}
          </CustomAvatarGroup>
        </Stack>
      </TableCellCustom>
    </>
  );
};

export { ClientDetailsRow };
